<dashboardnav>
<div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>

  <div *ngIf="
  !(isLoadingCountry$ | async) &&
  !(isLoadingState$ | async) &&
  !(isLoadingLga$ | async) &&
  !(isLoadingCommunity$ | async) &&
  !(isLoadingScholarshipType$ | async) &&
  !(isLoadingScholarshipAwardDuration$ | async) &&
  !(isLoadingCourseOfStudy$ | async) &&
  !(isLoadingScholarshipCategory$ | async) &&
  !(isLoadingScholarshipSession$ | async) &&
  !(isLoadingGender$ | async) &&
  !(isLoadingBank$ | async) &&
  !(isLoadingCurrency$ | async) &&
  !(isLoadingBankDetail$ | async)
  " >

<div class="container">
<div class="row">
  <div class="col-sm-3 mt-4 ml-5">
<mat-form-field class="full-width-field">
    <mat-label>Select Scholarship Reference Form</mat-label>
    <mat-select
    (selectionChange)="selectReference($event)" >
      <mat-option>None</mat-option>
      <mat-option class="option" *ngFor="let item of items" [value]="item.id"
        >{{ item.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- <main id="logout-button-holder">
    <button mat-raised-button id="logout-button" (click)="openLogoutModal()">Logout</button>
    <button mat-raised-button id="delete-product-button" (click)="openDeleteProductModal()">Delete Product</button>
  </main> -->
  </div>
</div>
</div>
</div>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase="reference">
      <mrsoftapps-reference-form-view
        [countries]="country$ | async"
        [states]="state$ | async"
        [lgas]="lga$ | async"
        [scholarshipTypes]="scholarshipType$ | async"
        [scholarshipCategories]="scholarshipCategory$ | async"
        [scholarshipSessions]="scholarshipSession$ | async"
        [scholarshipAwardDurations]="scholarshipAwardDuration$ | async"
        [communities]="community$ | async"
        [courseOfStudies]="courseOfStudy$ | async"
        [banks]="bank$ | async"
        [bankDetails]="bankDetail$ | async"
        [currencies]="currency$ | async"
        [genders]="gender$ | async"
        [data]="data"
        (changeEmit)="onSubmitCountry($event)"
        (deleteEvent)="onDelete($event)"
        *ngIf="!(isLoadingCountry$ | async)"
      >
      </mrsoftapps-reference-form-view>
    </ng-template>
  </div>
  <mrsoftapps-epims-reference-spinner *ngIf="
  (isLoadingCountry$ | async) ||
  (isLoadingState$ | async) ||
  (isLoadingLga$ | async) ||
  (isLoadingCommunity$ | async) ||
  (isLoadingScholarshipType$ | async) ||
  (isLoadingScholarshipAwardDuration$ | async) ||
  (isLoadingCourseOfStudy$ | async) ||
  (isLoadingScholarshipCategory$ | async) ||
  (isLoadingScholarshipSession$ | async) ||
  (isLoadingGender$ | async) ||
  (isLoadingBank$ | async) ||
  (isLoadingCurrency$ | async) ||
  (isLoadingBankDetail$ | async)
  ">
  </mrsoftapps-epims-reference-spinner>
  </main>
  </div>
</dashboardnav>
